import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LangSwitch } from "@/components/fly/LangSwitch";
import { useT } from "@/lib/i18n";

export const BackButton = ({ to = "/", label = "Cofnij" }) => {
  const nav = useNavigate();
  return (
    <button data-testid="back-btn" onClick={() => nav(to)}
      className="no-print h-10 px-3 rounded-lg border border-white/10 text-slate-300 hover:text-white hover:bg-white/5 flex items-center gap-2 text-sm shrink-0">
      <ArrowLeft className="w-4 h-4" /><span className="hidden sm:inline">{label}</span>
    </button>
  );
};

export const Logo = ({ size = "md" }) => {
  const big = size === "lg";
  return (
    <Link to="/" data-testid="logo-home-link" className="inline-flex items-center gap-2 sm:gap-3 select-none min-w-0">
      <img src="/strefa-fly-logo-white.png" alt="Strefa Fly" data-testid="strefa-fly-logo" className={`${big ? "h-16 sm:h-28" : "h-8 sm:h-10"} w-auto shrink-0`} />
      <img src="/flycup-logo-white.svg" alt="FLY CUP" data-testid="flycup-logo" className={`${big ? "h-20 sm:h-32" : "h-9 sm:h-11"} w-auto shrink-0`} />
    </Link>
  );
};

export const TopBar = ({ title, right, back = "/", lang }) => {
  const { t } = useT();
  return (
  <header className="no-print sticky top-0 z-30 backdrop-blur-xl bg-[#0B132B]/80 border-b border-blue-500/15">
    <div className="max-w-7xl mx-auto px-3 sm:px-6 h-16 flex items-center justify-between gap-2 sm:gap-4">
      <div className="flex items-center gap-2 sm:gap-4 min-w-0">
        {back && <BackButton to={back} label={lang ? t("back") : undefined} />}
        <Logo />
        {title && <span className="hidden sm:inline font-mono text-xs uppercase tracking-[0.2em] text-slate-400 truncate">/ {title}</span>}
      </div>
      <div className="flex items-center gap-2 shrink-0">{right}{lang && <LangSwitch />}</div>
    </div>
  </header>
  );
};
